<form (ngSubmit)="changePassword()" [formGroup]="changePasswordForm">
	<div class="modal-header">
		<h5 class="modal-title" id="modal-basic-title">Change Password</h5>
		<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="text-center">
			<u>Password Requirements</u><br />
			Must be at least 10 characters in Length.<br />
			Cannot match any of the passwords in our list of commonly used passwords.<br />
			Cannot contain repeating or sequential characters <br />
			(Examples of Repeating or Sequential Characters: "aaa", "abc", "123", etc.)<br />
		</div>
		<div class="row">
			<pcg-control-group class="col-sm-12" label="Current Password">
				<input pcgControlRef formControlName="currentPassword" type="password" class="form-control" />
			</pcg-control-group>
		</div>
		<div class="row">
			<pcg-control-group
				[validations]="{ commonPassword: 'Pick a less common password.' }"
				class="col-sm-12"
				label="New Password"
			>
				<input pcgControlRef formControlName="password" type="password" class="form-control" />
			</pcg-control-group>
		</div>
		<div class="row">
			<pcg-control-group
				[validations]="{ passwordsNotEqual: 'Passwords do not match.' }"
				class="col-sm-12"
				label="Confirm New Password"
			>
				<input pcgControlRef formControlName="confirmPassword" type="password" class="form-control" />
			</pcg-control-group>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-cancel btn-lg" (click)="activeModal.dismiss()">Cancel</button>
		<button type="submit" class="btn btn-save btn-lg">Change Password</button>
	</div>
</form>
